// extracted by mini-css-extract-plugin
export default {"select":"BanquetRoomPicker_select__TNMBh"};